import { APIEvent } from '../events/apiEvent'
import { EventBus } from '../event-bus'
import { StatusBarEvent } from '../events/statusBarEvent'

export default {

  mounted: function () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchAPIs()
      this.fetchRoleAPIs()
      if (this.$store.state.userRoles.length < 1) {
        let options = {}
        options.start_record = '0'
        this.$store.dispatch(APIEvent.FETCH_USER_ROLES, options)
          .then(() => {
            this.fetchUsers()
          })
      } else {
        this.fetchUsers()
      }

      this.$store.dispatch(APIEvent.FETCH_TENANT_GROUPS, {})
        .then(() => {
          this.tenantGroupList = this.$store.state.tenantGroupList
        })
        .catch(this.handleError)
    }
  },
  destroyed: function () {
    let options = {}
    options.prop = 'SET_USER_ROLES'
    options.value = []
    this.$store.dispatch(APIEvent.CLEAR, options)
  },
  computed: {
    apiList: function () { return this.$store.state.apiList },
    apiRoleList: function () { return this.$store.state.apiRoleList },
    userRoles: function () { return this.$store.state.userRoles.sort(this.sort) },
    userList: function () { return this.$store.state.userList },
    tenants: function () { return this.$store.state.tenantsList },
    languages: function () {
      let options = []
      let defaultOpt = {}
      defaultOpt.value = null
      defaultOpt.text = 'Please select...'
      defaultOpt.disabled = true
      options.push(defaultOpt)

      let langs = this.$store.state.languageList
      for (let i = 0; i < langs.length; i++) {
        const lang = langs[i]
        let option = {}
        option.value = lang.id
        option.text = lang.description
        options.push(option)
      }
      return options
    }
  },

  data: function () {
    return {
      checkedAPIs: [],
      checked: [],
      APIs: [],
      RoleAPIs: [],
      tenantGroupName: '',
      startOffset: 0,
      selectedCount: 0,
      tenantSelection: null,
      selected: {
        selectedTenantID: null,
        selectedTenantName: null,
        selectedTenantGroup: null,
        selectedTenantGroupName: null
      },
      roleSelection: this.$store.state.roleID,
      perPage: 200,
      currentPage: 1,
      hasNextPage: false,
      pageNumber: 1,
      tenantGroupList: [],
      selectedUser: {},
      newUser: {},
      newUserData: {
        email: '',
        role: null,
        tenant: null,
        tenantGroup: null,
        tenantGroupName: null,
        language: null
      },
      fields: {
        apiID: {
          label: 'id',
          tdClass: 'width-50'
        },
        apiName: {
          label: 'Name of API',
          tdClass: 'width-50'
        }
      },
      pageOptions: [
        {text: 5, value: 5},
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 50, value: 50},
        {text: 100, value: 100},
        {text: 200, value: 200}
      ]
    }
  },

  methods: {
    shouldBeChecked (val) {
      return this.checkedAPIs.includes(val)
    },
    updateVals (e) {
      let isChecked = e.target.checked
      let val = e.target.value

      if (isChecked) {
        this.checkedVals.push(val)
      } else {
        this.checkVals.splice(this.checkedVals.indexOf(val), 1)
      }
    },
    updateAPIs (e) {
      if (typeof e !== 'undefined') {
        let isChecked = e.target.checked
        let val = e.target.value

        if (isChecked) {
          this.checkedAPIs.push(val)
        } else {
          this.checkedAPIs.splice(this.checkedAPIs.indexOf(val), 1)
        }
      }
    },
    fetchAPIs: function () {
      this.$store.dispatch(APIEvent.FETCH_API)
        .then((res) => {
          this.records = res.data.list.records
          let apis = this.records.sort(this.compare)
          for (let i = 0; i < apis.length; i++) {
            let apiID = apis[i].id
            let apiName = apis[i].service + '/' + apis[i].object + '/' + apis[i].event
            this.APIs.push({apiName, apiID})
          }
        })
        .catch(this.handleError)
      this.$store.commit('SET_API_LIST', this.APIs)
    },
    fetchRoleAPIs: function () {
      this.$store.dispatch(APIEvent.FETCH_ROLE_API, {role_id: this.roleSelection.toString()})
        .then((res) => {
          if (res.data.list.hasOwnProperty('records')) {
            this.records = res.data.list.records
            let apis = this.records.sort(this.compare)
            for (let i = 0; i < apis.length; i++) {
              let apiID = apis[i].id
              this.checkedAPIs.push(apiID)
            }
          } else {
            // all checkboxes are unchecked
            this.checkedAPIs = []
          }
        })
        .catch(this.handleError)
    },
    compare: function (obj1, obj2) {
      const serviceA = obj1.service
      const serviceB = obj2.service

      let comparison = 0
      if (serviceA > serviceB) {
        comparison = 1
      } else if (serviceA < serviceB) {
        comparison = -1
      }
      return comparison
    },
    sort: function (obj1, obj2) {
      const nameA = obj1.name
      const nameB = obj2.name

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    },
    clickHandler (e) {
      let apiID = e.target.value
      let checkedBoolean = e.target.checked
      let options = {}
      options.role_id = this.roleSelection.toString()
      options.service_id = apiID
      if (checkedBoolean === true) {
        // console.log('Call GrantApi')
        this.$store.dispatch(APIEvent.ADD_API_TO_ROLE, options)
          .then((res) => {
            if (res.data.ack) {
              EventBus.$emit(StatusBarEvent.SUCCESS, 'API successfully added to role')
            }
          })
          .catch(this.handleError)
      } else {
        // console.log('Call RevokeApi')
        this.$store.dispatch(APIEvent.REMOVE_API_FROM_ROLE, options)
          .then((res) => {
            if (res.data.ack) {
              EventBus.$emit(StatusBarEvent.SUCCESS, 'API successfully removed from role')
            }
          })
          .catch(this.handleError)
      }
    },
    fetchUsers: function () {
      let options = {}
      options.fetch_size = this.perPage.toString()
      options.start_record = this.startOffset.toString()
      if (this.roleSelection !== undefined) { options.role_id = this.roleSelection.toString() }
      this.$store.dispatch(APIEvent.FETCH_USERS, options)
        .then((res) => {
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    onChange: function (event) {
      this.roleSelection = event.target.value
      this.startOffset = 0
      this.pageNumber = 1
      this.checkedAPIs = []
      this.fetchRoleAPIs()
    },
    handleError: function (error, message) {
      if (!error.error === 307) {
        message = typeof message === 'undefined'
          ? error.message
          : message + error.message
        EventBus.$emit(StatusBarEvent.ERROR, message)
      }
      if (error.error === 1003 ||
        error.error === 0 ||
        error.error === 205 ||
        error.error === 59 ||
        error.error === 1034) {
        EventBus.$emit(StatusBarEvent.ERROR, error.message)
      }
    }
  }
}
